import React from 'react';
import Alert from 'react-bootstrap/Alert';

class SSUtils extends React.Component {

  static getSupportUs() {
    return (<div className="notification">
        Like Smart Stake tools? Support us by delegating/bonding with Smart Stake.
        </div>);
    // return (<Alert variant="info">Like Smart Stake tools? Support us by delegating with Smart Stake&nbsp;
    //   <a href="https://station.terra.money/validator/terravaloper1alpf6snw2d76kkwjv3dp4l7pcl6cn9uyt0tcj9"
    //    className="black-a" target="_blank">here</a>.</Alert>)
    //&nbsp;-&nbsp;
    // <a href="https://station.terra.money/validator/terravaloper1alpf6snw2d76kkwjv3dp4l7pcl6cn9uyt0tcj9"
    // className="" target="_blank">Click here</a>
  }

}

export default SSUtils;



// WEBPACK FOOTER //
// ./src/util/SSUtils.js